import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../Styles/globalStyle.css";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import FormSettings from "../../Settings/FormSettings/FormSettings";
import uuid from "react-native-uuid";
import { store } from "../../../store.js";
import SaveCommand from "../../Commands/SaveCommand/SaveCommand";
import AddCommand from "../../Commands/AddCommand/AddCommand";
import CloseCommand from "../../Commands/CloseCommand/CloseCommand";
import useGetCurrentsTools from "../../../Hooks/useGetCurrentsTools.js";
import SimpleDialog from "../../SimpleDialog/SimpleDialog";

export default function List(props) {
  const axiosOperation = useAxiosOperation();
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const getCurrentsTools = useGetCurrentsTools();
  const firstNameId = 2;
  const lastNameId = 3;
  const emailId = 4;
  const headerFirstNameId = 15;
  const headerLastNameId = 19;
  const headerEmailId = 27;
  const formData ={ currentMaxId:49 , metaData :[{
   "metaData": [
     {
       "id": 5,
       "order": 2,
       "type": "Label",
       "properties": {
         "name": {
           "value": "Label5",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "text": {
           "value": "Requests",
           "control": "TextBox"
         },
         "readOnly": {
           "value": true,
           "control": "CheckBox",
           "hide": true
         },
         "eventInfo": {
           "value": false,
           "control": "CheckBox"
         },
         "type": {
           "value": "",
           "control": "ListBox",
           "values": [
             {
               "id": "0",
               "item": "",
               "value": ""
             },
             {
               "id": "1",
               "item": "H1",
               "value": "H1"
             },
             {
               "id": "2",
               "item": "H2",
               "value": "H2"
             },
             {
               "id": "3",
               "item": "H3",
               "value": "H3"
             },
             {
               "id": "4",
               "item": "H4",
               "value": "H4"
             },
             {
               "id": "5",
               "item": "H5",
               "value": "H5"
             },
             {
               "id": "6",
               "item": "H6",
               "value": "H6"
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "18px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "visibility": {
           "value": "visible"
         },
         "left": {
           "value": 17.5,
           "hide": true
         },
         "top": {
           "value": 17,
           "hide": true
         },
         "width": {
           "value": "146px",
           "hide": true
         },
         "paddingTop": {
           "value": "3px",
           "hide": true
         },
         "height": {
           "value": "28px",
           "hide": true
         },
         "border": {
           "value": "none"
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 17.5
       },
       "top": {
         "value": 19
       },
       "globalId": "1a39fc1f-e6a6-48ea-bbd9-d99593056aac",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 8,
       "order": 2,
       "type": "Label",
       "properties": {
         "name": {
           "value": "Label8",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "text": {
           "value": "Process:",
           "control": "TextBox"
         },
         "readOnly": {
           "value": true,
           "control": "CheckBox",
           "hide": true
         },
         "eventInfo": {
           "value": false,
           "control": "CheckBox"
         },
         "type": {
           "value": "",
           "control": "ListBox",
           "values": [
             {
               "id": "0",
               "item": "",
               "value": ""
             },
             {
               "id": "1",
               "item": "H1",
               "value": "H1"
             },
             {
               "id": "2",
               "item": "H2",
               "value": "H2"
             },
             {
               "id": "3",
               "item": "H3",
               "value": "H3"
             },
             {
               "id": "4",
               "item": "H4",
               "value": "H4"
             },
             {
               "id": "5",
               "item": "H5",
               "value": "H5"
             },
             {
               "id": "6",
               "item": "H6",
               "value": "H6"
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "visibility": {
           "value": "visible"
         },
         "left": {
           "value": 18,
           "hide": true
         },
         "top": {
           "value": 52,
           "hide": true
         },
         "width": {
           "value": "69px",
           "hide": true
         },
         "paddingTop": {
           "value": "3px",
           "hide": true
         },
         "height": {
           "value": "22px",
           "hide": true
         },
         "border": {
           "value": "none"
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 18
       },
       "top": {
         "value": 66
       },
       "globalId": "f8cb6a06-3cc2-4102-b038-1517ceedc33b",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 9,
       "order": 2,
       "type": "ListBox",
       "properties": {
         "name": {
           "value": "ListBox9",
           "control": "TextBox"
         },
         "field": {
           "value": "ListBox",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "menuItem": {
           "value": false,
           "control": "CheckBox",
           "hide": true
         },
         "width": {
           "value": "200px",
           "control": "TextBox"
         },
         "type": {
           "value": "String",
           "control": "ListBox",
           "hide": true
         },
         "toolTip": {
           "value": true,
           "control": "CheckBox"
         },
         "toolTipText": {
           "value": "",
           "control": "TextBox"
         },
         "actualize": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "size": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "nullable": {
           "value": true,
           "control": "CheckBox"
         },
         "text": {
           "value": {
             "id": null,
             "item": ""
           },
           "control": "TextBox"
         },
         "index": {
           "value": false,
           "control": "CheckBox"
         },
         "data": {
           "value": {
             "list": {},
             "mapping": {},
             "tree": {
               "treeDataType": "Form"
             }
           },
           "options": [
             "List",
             "Mapping"
           ],
           "control": "TextBox"
         },
         "validations": {
           "value": "",
           "control": "ListBoxCheckBox",
           "selectedValues": [],
           "values": [
             {
               "id": "1",
               "item": "REQUIRE",
               "value": {
                 "id": "1",
                 "type": "REQUIRE",
                 "events": [
                   "onBlur",
                   "onSubmit"
                 ]
               }
             },
             {
               "id": "4",
               "item": "UNIQUE",
               "value": {
                 "id": "4",
                 "type": "UNIQUE",
                 "events": [
                   "onBlur"
                 ]
               }
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "left": {
           "value": 93,
           "hide": true
         },
         "top": {
           "value": 52,
           "hide": true
         },
         "width": {
           "value": "157px",
           "hide": true
         },
         "height": {
           "value": "24px",
           "hide": true
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         },
         "position": {
           "value": "absolute"
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 93
       },
       "top": {
         "value": 55
       },
       "globalId": "6ce3f99e-6c4e-4015-8aaa-23c37603bd42",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 10,
       "order": 2,
       "type": "Label",
       "properties": {
         "name": {
           "value": "Label10",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "text": {
           "value": "Status:",
           "control": "TextBox"
         },
         "readOnly": {
           "value": true,
           "control": "CheckBox",
           "hide": true
         },
         "eventInfo": {
           "value": false,
           "control": "CheckBox"
         },
         "type": {
           "value": "",
           "control": "ListBox",
           "values": [
             {
               "id": "0",
               "item": "",
               "value": ""
             },
             {
               "id": "1",
               "item": "H1",
               "value": "H1"
             },
             {
               "id": "2",
               "item": "H2",
               "value": "H2"
             },
             {
               "id": "3",
               "item": "H3",
               "value": "H3"
             },
             {
               "id": "4",
               "item": "H4",
               "value": "H4"
             },
             {
               "id": "5",
               "item": "H5",
               "value": "H5"
             },
             {
               "id": "6",
               "item": "H6",
               "value": "H6"
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "visibility": {
           "value": "visible"
         },
         "left": {
           "value": 263,
           "hide": true
         },
         "top": {
           "value": 52,
           "hide": true
         },
         "width": {
           "value": "53px",
           "hide": true
         },
         "paddingTop": {
           "value": "3px",
           "hide": true
         },
         "height": {
           "value": "20px",
           "hide": true
         },
         "border": {
           "value": "none"
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 253
       },
       "top": {
         "value": 70
       },
       "globalId": "c12de3a3-831e-4d47-99e1-4a8efee0b3f2",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 13,
       "order": 2,
       "type": "ListBox",
       "properties": {
         "name": {
           "value": "ListBox13",
           "control": "TextBox"
         },
         "field": {
           "value": "ListBox",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "menuItem": {
           "value": false,
           "control": "CheckBox",
           "hide": true
         },
         "width": {
           "value": "200px",
           "control": "TextBox"
         },
         "type": {
           "value": "String",
           "control": "ListBox",
           "hide": true
         },
         "toolTip": {
           "value": true,
           "control": "CheckBox"
         },
         "toolTipText": {
           "value": "",
           "control": "TextBox"
         },
         "actualize": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "size": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "nullable": {
           "value": true,
           "control": "CheckBox"
         },
         "text": {
           "value": {
             "id": null,
             "item": ""
           },
           "control": "TextBox"
         },
         "index": {
           "value": false,
           "control": "CheckBox"
         },
         "data": {
           "value": {
             "list": {
               "id": 0,
               "maxId": 0,
               "values": [
                 {
                   "id": 0,
                   "item": "Status",
                   "value": "",
                   "details": [
                     {
                       "id": 0,
                       "option": "List",
                       "key": {
                         "id": "Listkey0",
                         "value": "1",
                         "isClick": false
                       },
                       "value": {
                         "id": "Listvalue0",
                         "value": "Open",
                         "isClick": false
                       }
                     },
                     {
                       "id": 1,
                       "option": "List",
                       "key": {
                         "id": "Listkey1",
                         "value": "2",
                         "isClick": false
                       },
                       "value": {
                         "id": "Listvalue1",
                         "value": "Closed",
                         "isClick": false
                       }
                     }
                   ]
                 }
               ],
               "detailsId": 1,
               "maxDetailsId": 1
             },
             "mapping": {},
             "tree": {
               "treeDataType": "Form"
             }
           },
           "options": [
             "List",
             "Mapping"
           ],
           "control": "TextBox",
           "option": "List"
         },
         "validations": {
           "value": "",
           "control": "ListBoxCheckBox",
           "selectedValues": [],
           "values": [
             {
               "id": "1",
               "item": "REQUIRE",
               "value": {
                 "id": "1",
                 "type": "REQUIRE",
                 "events": [
                   "onBlur",
                   "onSubmit"
                 ]
               }
             },
             {
               "id": "4",
               "item": "UNIQUE",
               "value": {
                 "id": "4",
                 "type": "UNIQUE",
                 "events": [
                   "onBlur"
                 ]
               }
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "left": {
           "value": 316,
           "hide": true
         },
         "top": {
           "value": 52,
           "hide": true
         },
         "width": {
           "value": "100px",
           "hide": true
         },
         "height": {
           "value": "25px",
           "hide": true
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         },
         "position": {
           "value": "absolute"
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 296
       },
       "top": {
         "value": 57
       },
       "globalId": "3e30b133-77a9-47bb-ae54-e539ce199d8b",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 12,
       "order": 2,
       "type": "Label",
       "properties": {
         "name": {
           "value": "Label12",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "text": {
           "value": "Between",
           "control": "TextBox"
         },
         "readOnly": {
           "value": true,
           "control": "CheckBox",
           "hide": true
         },
         "eventInfo": {
           "value": false,
           "control": "CheckBox"
         },
         "type": {
           "value": "",
           "control": "ListBox",
           "values": [
             {
               "id": "0",
               "item": "",
               "value": ""
             },
             {
               "id": "1",
               "item": "H1",
               "value": "H1"
             },
             {
               "id": "2",
               "item": "H2",
               "value": "H2"
             },
             {
               "id": "3",
               "item": "H3",
               "value": "H3"
             },
             {
               "id": "4",
               "item": "H4",
               "value": "H4"
             },
             {
               "id": "5",
               "item": "H5",
               "value": "H5"
             },
             {
               "id": "6",
               "item": "H6",
               "value": "H6"
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "visibility": {
           "value": "visible"
         },
         "left": {
           "value": 19,
           "hide": true
         },
         "top": {
           "value": 87,
           "hide": true
         },
         "width": {
           "value": "67px",
           "hide": true
         },
         "paddingTop": {
           "value": "3px",
           "hide": true
         },
         "height": {
           "value": "23px",
           "hide": true
         },
         "border": {
           "value": "none"
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 19
       },
       "top": {
         "value": 91
       },
       "globalId": "aa576945-e110-4801-8646-02d88656d439",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 14,
       "order": 2,
       "type": "DateTime",
       "properties": {
         "name": {
           "value": "DateTime14",
           "control": "TextBox"
         },
         "field": {
           "value": "DateTime",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "type": {
           "value": "DateTime",
           "control": "ListBox",
           "hide": true
         },
         "nullable": {
           "value": true,
           "control": "CheckBox"
         },
         "text": {
           "value": "",
           "control": "TextBox"
         },
         "index": {
           "value": false,
           "control": "CheckBox"
         },
         "date": {
           "value": true,
           "control": "CheckBox"
         },
         "dateFormat": {
           "value": "dd/mm/yyyy",
           "values": [
             {
               "id": "1",
               "item": "dd/mm/yyyy",
               "value": "dd/mm/yyyy"
             },
             {
               "id": "2",
               "item": "mm/dd/yyyy",
               "value": "mm/dd/yyyy"
             },
             {
               "id": "3",
               "item": "yyyy/mm/dd",
               "value": "yyyy/mm/dd"
             },
             {
               "id": "4",
               "item": "yyyy/dd/mm",
               "value": "yyyy/dd/mm"
             }
           ],
           "type": "Date",
           "control": "ListBox"
         },
         "time": {
           "value": false,
           "control": "CheckBox"
         },
         "timeFormat": {
           "value": "hh:mm:ss",
           "values": [
             {
               "id": "1",
               "item": "hh:mm:ss",
               "value": "hh:mm:ss"
             },
             {
               "id": "2",
               "item": "hh:mm",
               "value": "hh:mm"
             },
             {
               "id": "3",
               "item": "hh",
               "value": "hh"
             },
             {
               "id": "4",
               "item": "mm",
               "value": "mm"
             },
             {
               "id": "5",
               "item": "ss",
               "value": "ss"
             }
           ],
           "type": "Time",
           "control": "ListBox"
         },
         "operators": {
           "value": "",
           "control": "ListBoxCheckBox",
           "selectedValues": [],
           "values": [
             {
               "id": "1",
               "item": "equal",
               "value": {
                 "id": "1",
                 "type": "equal"
               }
             },
             {
               "id": "2",
               "item": "not equal",
               "value": {
                 "id": "2",
                 "type": "not equal"
               }
             },
             {
               "id": "3",
               "item": "greater",
               "value": {
                 "id": "3",
                 "type": "greater"
               }
             },
             {
               "id": "4",
               "item": "greater & equal",
               "value": {
                 "id": "4",
                 "type": "greater & equal"
               }
             },
             {
               "id": "5",
               "item": "lower",
               "value": {
                 "id": "5",
                 "type": "lower"
               }
             },
             {
               "id": "6",
               "item": "lower & equal",
               "value": {
                 "id": "6",
                 "type": "lower & equal"
               }
             }
           ]
         },
         "validations": {
           "value": "",
           "control": "ListBoxCheckBox",
           "selectedValues": [],
           "values": [
             {
               "id": "1",
               "item": "REQUIRE",
               "value": {
                 "id": "1",
                 "type": "REQUIRE",
                 "events": [
                   "onBlur",
                   "onSubmit"
                 ]
               }
             },
             {
               "id": "4",
               "item": "UNIQUE",
               "value": {
                 "id": "4",
                 "type": "UNIQUE",
                 "events": [
                   "onBlur"
                 ]
               }
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "height": {
           "value": "25px"
         },
         "width": {
           "value": "105px",
           "hide": true
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "alignItems": {
           "value": "center",
           "hide": true
         },
         "left": {
           "value": 96,
           "hide": true
         },
         "top": {
           "value": 87,
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 96
       },
       "top": {
         "value": 92
       },
       "globalId": "d545fda7-a0df-4098-a3a9-9bdc866de6e7",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 15,
       "order": 2,
       "type": "Label",
       "properties": {
         "name": {
           "value": "Label15",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "text": {
           "value": "And",
           "control": "TextBox"
         },
         "readOnly": {
           "value": true,
           "control": "CheckBox",
           "hide": true
         },
         "eventInfo": {
           "value": false,
           "control": "CheckBox"
         },
         "type": {
           "value": "",
           "control": "ListBox",
           "values": [
             {
               "id": "0",
               "item": "",
               "value": ""
             },
             {
               "id": "1",
               "item": "H1",
               "value": "H1"
             },
             {
               "id": "2",
               "item": "H2",
               "value": "H2"
             },
             {
               "id": "3",
               "item": "H3",
               "value": "H3"
             },
             {
               "id": "4",
               "item": "H4",
               "value": "H4"
             },
             {
               "id": "5",
               "item": "H5",
               "value": "H5"
             },
             {
               "id": "6",
               "item": "H6",
               "value": "H6"
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "visibility": {
           "value": "visible"
         },
         "left": {
           "value": 222,
           "hide": true
         },
         "top": {
           "value": 87,
           "hide": true
         },
         "width": {
           "value": "55px",
           "hide": true
         },
         "paddingTop": {
           "value": "3px",
           "hide": true
         },
         "height": {
           "value": "22px",
           "hide": true
         },
         "border": {
           "value": "none"
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 222
       },
       "top": {
         "value": 99
       },
       "globalId": "bcd1ddc0-b740-4963-8694-402b1b7f827a",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 16,
       "order": 2,
       "type": "DateTime",
       "properties": {
         "name": {
           "value": "DateTime16",
           "control": "TextBox"
         },
         "field": {
           "value": "DateTime",
           "control": "TextBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "type": {
           "value": "DateTime",
           "control": "ListBox",
           "hide": true
         },
         "nullable": {
           "value": true,
           "control": "CheckBox"
         },
         "text": {
           "value": "",
           "control": "TextBox"
         },
         "index": {
           "value": false,
           "control": "CheckBox"
         },
         "date": {
           "value": true,
           "control": "CheckBox"
         },
         "dateFormat": {
           "value": "dd/mm/yyyy",
           "values": [
             {
               "id": "1",
               "item": "dd/mm/yyyy",
               "value": "dd/mm/yyyy"
             },
             {
               "id": "2",
               "item": "mm/dd/yyyy",
               "value": "mm/dd/yyyy"
             },
             {
               "id": "3",
               "item": "yyyy/mm/dd",
               "value": "yyyy/mm/dd"
             },
             {
               "id": "4",
               "item": "yyyy/dd/mm",
               "value": "yyyy/dd/mm"
             }
           ],
           "type": "Date",
           "control": "ListBox"
         },
         "time": {
           "value": false,
           "control": "CheckBox"
         },
         "timeFormat": {
           "value": "hh:mm:ss",
           "values": [
             {
               "id": "1",
               "item": "hh:mm:ss",
               "value": "hh:mm:ss"
             },
             {
               "id": "2",
               "item": "hh:mm",
               "value": "hh:mm"
             },
             {
               "id": "3",
               "item": "hh",
               "value": "hh"
             },
             {
               "id": "4",
               "item": "mm",
               "value": "mm"
             },
             {
               "id": "5",
               "item": "ss",
               "value": "ss"
             }
           ],
           "type": "Time",
           "control": "ListBox"
         },
         "operators": {
           "value": "",
           "control": "ListBoxCheckBox",
           "selectedValues": [],
           "values": [
             {
               "id": "1",
               "item": "equal",
               "value": {
                 "id": "1",
                 "type": "equal"
               }
             },
             {
               "id": "2",
               "item": "not equal",
               "value": {
                 "id": "2",
                 "type": "not equal"
               }
             },
             {
               "id": "3",
               "item": "greater",
               "value": {
                 "id": "3",
                 "type": "greater"
               }
             },
             {
               "id": "4",
               "item": "greater & equal",
               "value": {
                 "id": "4",
                 "type": "greater & equal"
               }
             },
             {
               "id": "5",
               "item": "lower",
               "value": {
                 "id": "5",
                 "type": "lower"
               }
             },
             {
               "id": "6",
               "item": "lower & equal",
               "value": {
                 "id": "6",
                 "type": "lower & equal"
               }
             }
           ]
         },
         "validations": {
           "value": "",
           "control": "ListBoxCheckBox",
           "selectedValues": [],
           "values": [
             {
               "id": "1",
               "item": "REQUIRE",
               "value": {
                 "id": "1",
                 "type": "REQUIRE",
                 "events": [
                   "onBlur",
                   "onSubmit"
                 ]
               }
             },
             {
               "id": "4",
               "item": "UNIQUE",
               "value": {
                 "id": "4",
                 "type": "UNIQUE",
                 "events": [
                   "onBlur"
                 ]
               }
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "height": {
           "value": "28px"
         },
         "width": {
           "value": "111px",
           "hide": true
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "alignItems": {
           "value": "center",
           "hide": true
         },
         "left": {
           "value": 288,
           "hide": true
         },
         "top": {
           "value": 87,
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 288
       },
       "top": {
         "value": 100
       },
       "globalId": "ec39f808-701e-45ca-b4a7-8ec894fc61ef",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     },
     {
       "id": 17,
       "order": 2,
       "currentMaxId": 0,
       "type": "DataGrid",
       "selectedValues": [
         23,
         27,
         31,
         35,
         39,
         43,
         47
       ],
       "properties": {
         "name": {
           "value": "DataGrid17",
           "control": "TextBox"
         },
         "text": {
           "value": "DataGrid",
           "control": "TextBox"
         },
         "sliceStart": {
           "value": 1,
           "control": "TextBox"
         },
         "sliceSize": {
           "value": 10,
           "control": "TextBox"
         },
         "size": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "actualize": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "search": {
           "value": true,
           "control": "CheckBox"
         },
         "header": {
           "value": true,
           "control": "CheckBox"
         },
         "filter": {
           "value": true,
           "control": "CheckBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "add": {
           "value": false,
           "control": "CheckBox"
         },
         "delete": {
           "value": false,
           "control": "CheckBox"
         },
         "data": {
           "value": {
             "list": {},
             "mapping": {},
             "tree": {
               "treeDataType": "Form"
             },
             "input": {}
           },
           "options": [
             "Mapping"
           ],
           "control": "TextBox"
         }
       },
       "metaData": [
         {
           "id": 18,
           "order": 5,
           "currentMaxId": 0,
           "type": "SearchGrid",
           "properties": {
             "name": {
               "value": "SearchGrid18",
               "control": "TextBox"
             },
             "text": {
               "value": "SearchGrid",
               "control": "TextBox"
             }
           },
           "metaData": [],
           "policy": {
             "read": true,
             "edit": true,
             "delete": true
           },
           "styles": {
             "fontSize": {
               "value": "14px"
             },
             "fontFamily": {
               "value": "Arial"
             },
             "color": {
               "value": "#212121"
             },
             "backgroundColor": {
               "value": "#e7e7e7"
             },
             "height": {
               "value": "30px",
               "hide": true
             },
             "width": {
               "value": "100%",
               "hide": true
             },
             "display": {
               "value": "flex",
               "hide": true
             },
             "position": {
               "value": "relative",
               "hide": true
             },
             "boxSizing": {
               "value": "border-box",
               "hide": true
             },
             "overflow": {
               "value": "hidden",
               "hide": true
             },
             "border": {
               "value": "1px solid #cccccc"
             }
           },
           "left": {
             "value": 19
           },
           "top": {
             "value": 136
           },
           "globalId": "4aadc2e5-db69-4e4a-8230-e3f8460caac6",
           "parentId": [
             17,
             1
           ],
           "parentGlobalId": [
             "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
             "a4a285f5-8651-4a5a-8243-4428ff27cd27"
           ]
         },
         {
           "id": 19,
           "order": 5,
           "currentMaxId": 0,
           "type": "Header",
           "properties": {
             "name": {
               "value": "Header19",
               "control": "TextBox"
             },
             "text": {
               "value": "Header",
               "control": "TextBox"
             }
           },
           "metaData": [
             {
               "id": 23,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox23",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "Number",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "118px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "d7158127-0d8d-4686-aadc-6325f5190e28",
               "parentId": [
                 19,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "322d6023-81b2-42b7-813b-0fbf311fdb73",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ]
             },
             {
               "id": 27,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox27",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "Process",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "170px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "29647ac1-2608-4aac-ab3f-bb2e1ea3db02",
               "parentId": [
                 19,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "322d6023-81b2-42b7-813b-0fbf311fdb73",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ]
             },
             {
               "id": 35,
               "order": 2,
               "type": "DateTime",
               "properties": {
                 "name": {
                   "value": "DateTime35",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "DateTime",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "DateTime",
                   "control": "ListBox",
                   "hide": true
                 },
                 "nullable": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "text": {
                   "value": "Created at",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "date": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "dateFormat": {
                   "value": "dd/mm/yyyy",
                   "values": [
                     {
                       "id": "1",
                       "item": "dd/mm/yyyy",
                       "value": "dd/mm/yyyy"
                     },
                     {
                       "id": "2",
                       "item": "mm/dd/yyyy",
                       "value": "mm/dd/yyyy"
                     },
                     {
                       "id": "3",
                       "item": "yyyy/mm/dd",
                       "value": "yyyy/mm/dd"
                     },
                     {
                       "id": "4",
                       "item": "yyyy/dd/mm",
                       "value": "yyyy/dd/mm"
                     }
                   ],
                   "type": "Date",
                   "control": "ListBox"
                 },
                 "time": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "timeFormat": {
                   "value": "hh:mm:ss",
                   "values": [
                     {
                       "id": "1",
                       "item": "hh:mm:ss",
                       "value": "hh:mm:ss"
                     },
                     {
                       "id": "2",
                       "item": "hh:mm",
                       "value": "hh:mm"
                     },
                     {
                       "id": "3",
                       "item": "hh",
                       "value": "hh"
                     },
                     {
                       "id": "4",
                       "item": "mm",
                       "value": "mm"
                     },
                     {
                       "id": "5",
                       "item": "ss",
                       "value": "ss"
                     }
                   ],
                   "type": "Time",
                   "control": "ListBox"
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     }
                   ]
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "height": {
                   "value": "25px"
                 },
                 "width": {
                   "value": "106px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "alignItems": {
                   "value": "center",
                   "hide": true
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "resize": {
                   "value": "both"
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "24d6f910-cfa0-4624-bae5-0d1e45fff081",
               "parentId": [
                 19,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "322d6023-81b2-42b7-813b-0fbf311fdb73",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ]
             },
             {
               "id": 31,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox31",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "Current Step",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 6,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "147px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "dc80c543-f18d-40eb-8b46-e7039cf684d7",
               "parentId": [
                 19,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "322d6023-81b2-42b7-813b-0fbf311fdb73",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ]
             },
             {
               "id": 39,
               "order": 2,
               "type": "DateTime",
               "properties": {
                 "name": {
                   "value": "DateTime39",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "DateTime",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "DateTime",
                   "control": "ListBox",
                   "hide": true
                 },
                 "nullable": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "text": {
                   "value": "Updated at",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "date": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "dateFormat": {
                   "value": "dd/mm/yyyy",
                   "values": [
                     {
                       "id": "1",
                       "item": "dd/mm/yyyy",
                       "value": "dd/mm/yyyy"
                     },
                     {
                       "id": "2",
                       "item": "mm/dd/yyyy",
                       "value": "mm/dd/yyyy"
                     },
                     {
                       "id": "3",
                       "item": "yyyy/mm/dd",
                       "value": "yyyy/mm/dd"
                     },
                     {
                       "id": "4",
                       "item": "yyyy/dd/mm",
                       "value": "yyyy/dd/mm"
                     }
                   ],
                   "type": "Date",
                   "control": "ListBox"
                 },
                 "time": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "timeFormat": {
                   "value": "hh:mm:ss",
                   "values": [
                     {
                       "id": "1",
                       "item": "hh:mm:ss",
                       "value": "hh:mm:ss"
                     },
                     {
                       "id": "2",
                       "item": "hh:mm",
                       "value": "hh:mm"
                     },
                     {
                       "id": "3",
                       "item": "hh",
                       "value": "hh"
                     },
                     {
                       "id": "4",
                       "item": "mm",
                       "value": "mm"
                     },
                     {
                       "id": "5",
                       "item": "ss",
                       "value": "ss"
                     }
                   ],
                   "type": "Time",
                   "control": "ListBox"
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     }
                   ]
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "height": {
                   "value": "25px"
                 },
                 "width": {
                   "value": "103px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "alignItems": {
                   "value": "center",
                   "hide": true
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "7f5cc8d6-3ae5-447f-89de-9ab9616c271c",
               "parentId": [
                 19,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "322d6023-81b2-42b7-813b-0fbf311fdb73",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ]
             },
             {
               "id": 43,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox43",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "Decision",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "111px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "b1438fd2-60d7-4607-a9c1-293c2d572fca",
               "parentId": [
                 19,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "322d6023-81b2-42b7-813b-0fbf311fdb73",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ]
             },
             {
               "id": 47,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox47",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "Full Name",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "181px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "568b986a-f503-4455-aa30-7f375dc7b290",
               "parentId": [
                 19,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "322d6023-81b2-42b7-813b-0fbf311fdb73",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ]
             }
           ],
           "policy": {
             "read": true,
             "edit": true,
             "delete": true
           },
           "styles": {
             "fontSize": {
               "value": "14px"
             },
             "fontFamily": {
               "value": "Arial"
             },
             "color": {
               "value": "#cccccc"
             },
             "backgroundColor": {
               "value": "#e7e7e7"
             },
             "height": {
               "value": "30px",
               "hide": true
             },
             "width": {
               "value": "100%",
               "hide": true
             },
             "display": {
               "value": "flex",
               "hide": true
             },
             "position": {
               "value": "relative",
               "hide": true
             },
             "boxSizing": {
               "value": "border-box",
               "hide": true
             },
             "overflow": {
               "value": "hidden",
               "hide": true
             },
             "border": {
               "value": "1px solid #cccccc"
             }
           },
           "left": {
             "value": 19
           },
           "top": {
             "value": 136
           },
           "globalId": "322d6023-81b2-42b7-813b-0fbf311fdb73",
           "parentId": [
             17,
             1
           ],
           "parentGlobalId": [
             "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
             "a4a285f5-8651-4a5a-8243-4428ff27cd27"
           ]
         },
         {
           "id": 20,
           "order": 5,
           "currentMaxId": 0,
           "type": "Filter",
           "properties": {
             "name": {
               "value": "Filter20",
               "control": "TextBox"
             },
             "text": {
               "value": "Filter",
               "control": "TextBox"
             }
           },
           "metaData": [
             {
               "id": 25,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox25",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "118px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "a1f4f57b-57f3-4a59-aa65-aaa3d57c58df",
               "parentId": [
                 20,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "063fb412-ba4f-4595-a66c-e9c2b1863467",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 23
             },
             {
               "id": 29,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox29",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "170px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "bc0c1f89-6418-48ba-88de-b112df8d44cc",
               "parentId": [
                 20,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "063fb412-ba4f-4595-a66c-e9c2b1863467",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 27
             },
             {
               "id": 37,
               "order": 2,
               "type": "DateTime",
               "properties": {
                 "name": {
                   "value": "DateTime37",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "DateTime",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "DateTime",
                   "control": "ListBox",
                   "hide": true
                 },
                 "nullable": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "date": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "dateFormat": {
                   "value": "dd/mm/yyyy",
                   "values": [
                     {
                       "id": "1",
                       "item": "dd/mm/yyyy",
                       "value": "dd/mm/yyyy"
                     },
                     {
                       "id": "2",
                       "item": "mm/dd/yyyy",
                       "value": "mm/dd/yyyy"
                     },
                     {
                       "id": "3",
                       "item": "yyyy/mm/dd",
                       "value": "yyyy/mm/dd"
                     },
                     {
                       "id": "4",
                       "item": "yyyy/dd/mm",
                       "value": "yyyy/dd/mm"
                     }
                   ],
                   "type": "Date",
                   "control": "ListBox"
                 },
                 "time": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "timeFormat": {
                   "value": "hh:mm:ss",
                   "values": [
                     {
                       "id": "1",
                       "item": "hh:mm:ss",
                       "value": "hh:mm:ss"
                     },
                     {
                       "id": "2",
                       "item": "hh:mm",
                       "value": "hh:mm"
                     },
                     {
                       "id": "3",
                       "item": "hh",
                       "value": "hh"
                     },
                     {
                       "id": "4",
                       "item": "mm",
                       "value": "mm"
                     },
                     {
                       "id": "5",
                       "item": "ss",
                       "value": "ss"
                     }
                   ],
                   "type": "Time",
                   "control": "ListBox"
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     }
                   ]
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "height": {
                   "value": "25px"
                 },
                 "width": {
                   "value": "106px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "alignItems": {
                   "value": "center",
                   "hide": true
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "dc18d313-e382-4f03-a2e5-eef444c2059d",
               "parentId": [
                 20,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "063fb412-ba4f-4595-a66c-e9c2b1863467",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 35
             },
             {
               "id": 33,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox33",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "147px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "87e32960-d298-46b4-abe7-ffc3bc1c40a6",
               "parentId": [
                 20,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "063fb412-ba4f-4595-a66c-e9c2b1863467",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 31
             },
             {
               "id": 41,
               "order": 2,
               "type": "DateTime",
               "properties": {
                 "name": {
                   "value": "DateTime41",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "DateTime",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "DateTime",
                   "control": "ListBox",
                   "hide": true
                 },
                 "nullable": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "date": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "dateFormat": {
                   "value": "dd/mm/yyyy",
                   "values": [
                     {
                       "id": "1",
                       "item": "dd/mm/yyyy",
                       "value": "dd/mm/yyyy"
                     },
                     {
                       "id": "2",
                       "item": "mm/dd/yyyy",
                       "value": "mm/dd/yyyy"
                     },
                     {
                       "id": "3",
                       "item": "yyyy/mm/dd",
                       "value": "yyyy/mm/dd"
                     },
                     {
                       "id": "4",
                       "item": "yyyy/dd/mm",
                       "value": "yyyy/dd/mm"
                     }
                   ],
                   "type": "Date",
                   "control": "ListBox"
                 },
                 "time": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "timeFormat": {
                   "value": "hh:mm:ss",
                   "values": [
                     {
                       "id": "1",
                       "item": "hh:mm:ss",
                       "value": "hh:mm:ss"
                     },
                     {
                       "id": "2",
                       "item": "hh:mm",
                       "value": "hh:mm"
                     },
                     {
                       "id": "3",
                       "item": "hh",
                       "value": "hh"
                     },
                     {
                       "id": "4",
                       "item": "mm",
                       "value": "mm"
                     },
                     {
                       "id": "5",
                       "item": "ss",
                       "value": "ss"
                     }
                   ],
                   "type": "Time",
                   "control": "ListBox"
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     }
                   ]
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "height": {
                   "value": "25px"
                 },
                 "width": {
                   "value": "103px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "alignItems": {
                   "value": "center",
                   "hide": true
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "b33d2bee-3dfc-4df1-8200-897634ba859f",
               "parentId": [
                 20,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "063fb412-ba4f-4595-a66c-e9c2b1863467",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 39
             },
             {
               "id": 45,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox45",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "111px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "79dd51ab-bf15-4a95-a007-80792d7dc3ab",
               "parentId": [
                 20,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "063fb412-ba4f-4595-a66c-e9c2b1863467",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 43
             },
             {
               "id": 49,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox49",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "181px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "8bd32604-b0f5-4b05-bc7d-ed7f297be11d",
               "parentId": [
                 20,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "063fb412-ba4f-4595-a66c-e9c2b1863467",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 47
             }
           ],
           "policy": {
             "read": true,
             "edit": true,
             "delete": true
           },
           "styles": {
             "fontSize": {
               "value": "14px"
             },
             "fontFamily": {
               "value": "Arial"
             },
             "color": {
               "value": "#cccccc"
             },
             "backgroundColor": {
               "value": "white"
             },
             "height": {
               "value": "30px",
               "hide": true
             },
             "width": {
               "value": "100%",
               "hide": true
             },
             "display": {
               "value": "flex",
               "hide": true
             },
             "position": {
               "value": "relative",
               "hide": true
             },
             "boxSizing": {
               "value": "border-box",
               "hide": true
             },
             "overflow": {
               "value": "hidden",
               "hide": true
             },
             "border": {
               "value": "1px solid #cccccc"
             }
           },
           "left": {
             "value": 19
           },
           "top": {
             "value": 136
           },
           "globalId": "063fb412-ba4f-4595-a66c-e9c2b1863467",
           "parentId": [
             17,
             1
           ],
           "parentGlobalId": [
             "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
             "a4a285f5-8651-4a5a-8243-4428ff27cd27"
           ]
         },
         {
           "id": 21,
           "order": 5,
           "currentMaxId": 0,
           "type": "Rows",
           "properties": {
             "name": {
               "value": "Rows21",
               "control": "TextBox"
             },
             "text": {
               "value": "Rows",
               "control": "TextBox"
             }
           },
           "metaData": [
             {
               "id": 24,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "Number",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "Number",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "118px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "c0c0e06a-d017-4f8d-909e-c0a0f62924c9",
               "parentId": [
                 21,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "10b84a8f-adf0-40f1-9d59-9bd05510158b",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 23
             },
             {
               "id": 28,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "Process",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "170px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "6c0180c5-8d90-4308-8595-6267685d40e0",
               "parentId": [
                 21,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "10b84a8f-adf0-40f1-9d59-9bd05510158b",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 27
             },
             {
               "id": 36,
               "order": 2,
               "type": "DateTime",
               "properties": {
                 "name": {
                   "value": "CreatedAt",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "DateTime",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "DateTime",
                   "control": "ListBox",
                   "hide": true
                 },
                 "nullable": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "date": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "dateFormat": {
                   "value": "dd/mm/yyyy",
                   "values": [
                     {
                       "id": "1",
                       "item": "dd/mm/yyyy",
                       "value": "dd/mm/yyyy"
                     },
                     {
                       "id": "2",
                       "item": "mm/dd/yyyy",
                       "value": "mm/dd/yyyy"
                     },
                     {
                       "id": "3",
                       "item": "yyyy/mm/dd",
                       "value": "yyyy/mm/dd"
                     },
                     {
                       "id": "4",
                       "item": "yyyy/dd/mm",
                       "value": "yyyy/dd/mm"
                     }
                   ],
                   "type": "Date",
                   "control": "ListBox"
                 },
                 "time": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "timeFormat": {
                   "value": "hh:mm:ss",
                   "values": [
                     {
                       "id": "1",
                       "item": "hh:mm:ss",
                       "value": "hh:mm:ss"
                     },
                     {
                       "id": "2",
                       "item": "hh:mm",
                       "value": "hh:mm"
                     },
                     {
                       "id": "3",
                       "item": "hh",
                       "value": "hh"
                     },
                     {
                       "id": "4",
                       "item": "mm",
                       "value": "mm"
                     },
                     {
                       "id": "5",
                       "item": "ss",
                       "value": "ss"
                     }
                   ],
                   "type": "Time",
                   "control": "ListBox"
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     }
                   ]
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "height": {
                   "value": "25px"
                 },
                 "width": {
                   "value": "106px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "alignItems": {
                   "value": "center",
                   "hide": true
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "cb80179c-006c-458f-95c1-c83b6549095a",
               "parentId": [
                 21,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "10b84a8f-adf0-40f1-9d59-9bd05510158b",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 35
             },
             {
               "id": 32,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox32",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "147px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "6052c167-cd03-451d-a00c-55b6d88b11c0",
               "parentId": [
                 21,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "10b84a8f-adf0-40f1-9d59-9bd05510158b",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 31
             },
             {
               "id": 40,
               "order": 2,
               "type": "DateTime",
               "properties": {
                 "name": {
                   "value": "DateTime40",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "DateTime",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "DateTime",
                   "control": "ListBox",
                   "hide": true
                 },
                 "nullable": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "date": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "dateFormat": {
                   "value": "dd/mm/yyyy",
                   "values": [
                     {
                       "id": "1",
                       "item": "dd/mm/yyyy",
                       "value": "dd/mm/yyyy"
                     },
                     {
                       "id": "2",
                       "item": "mm/dd/yyyy",
                       "value": "mm/dd/yyyy"
                     },
                     {
                       "id": "3",
                       "item": "yyyy/mm/dd",
                       "value": "yyyy/mm/dd"
                     },
                     {
                       "id": "4",
                       "item": "yyyy/dd/mm",
                       "value": "yyyy/dd/mm"
                     }
                   ],
                   "type": "Date",
                   "control": "ListBox"
                 },
                 "time": {
                   "value": false,
                   "control": "CheckBox"
                 },
                 "timeFormat": {
                   "value": "hh:mm:ss",
                   "values": [
                     {
                       "id": "1",
                       "item": "hh:mm:ss",
                       "value": "hh:mm:ss"
                     },
                     {
                       "id": "2",
                       "item": "hh:mm",
                       "value": "hh:mm"
                     },
                     {
                       "id": "3",
                       "item": "hh",
                       "value": "hh"
                     },
                     {
                       "id": "4",
                       "item": "mm",
                       "value": "mm"
                     },
                     {
                       "id": "5",
                       "item": "ss",
                       "value": "ss"
                     }
                   ],
                   "type": "Time",
                   "control": "ListBox"
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     }
                   ]
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "height": {
                   "value": "25px"
                 },
                 "width": {
                   "value": "103px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "alignItems": {
                   "value": "center",
                   "hide": true
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "11db3e98-9db0-4764-92e2-ab2ad2c85dc7",
               "parentId": [
                 21,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "10b84a8f-adf0-40f1-9d59-9bd05510158b",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 39
             },
             {
               "id": 44,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "Decision",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "Decision",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "111px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "1169854e-1899-4894-86c5-91509d2de0e0",
               "parentId": [
                 21,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "10b84a8f-adf0-40f1-9d59-9bd05510158b",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 43
             },
             {
               "id": 48,
               "order": 2,
               "type": "TextBox",
               "properties": {
                 "name": {
                   "value": "TextBox48",
                   "control": "TextBox"
                 },
                 "field": {
                   "value": "TextBox",
                   "control": "TextBox"
                 },
                 "text": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "actions": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "readOnly": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "placeholder": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "toolTip": {
                   "value": true,
                   "control": "CheckBox"
                 },
                 "toolTipText": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "maxLength": {
                   "value": 200,
                   "control": "TextBox"
                 },
                 "type": {
                   "value": "String",
                   "control": "ListBox",
                   "values": [
                     {
                       "id": "0",
                       "item": "String",
                       "value": "String"
                     },
                     {
                       "id": "1",
                       "item": "Integer",
                       "value": "Integer"
                     },
                     {
                       "id": "2",
                       "item": "Decimal",
                       "value": "Decimal"
                     }
                   ]
                 },
                 "masks": {
                   "value": "",
                   "control": "TextBox",
                   "maskValue": ""
                 },
                 "validations": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "REQUIRE",
                       "value": {
                         "id": "1",
                         "type": "REQUIRE",
                         "events": [
                           "onBlur",
                           "onSubmit"
                         ]
                       }
                     },
                     {
                       "id": "2",
                       "item": "NUMBER",
                       "value": {
                         "id": "2",
                         "type": "NUMBER",
                         "events": [
                           "onChange",
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "3",
                       "item": "EMAIL",
                       "value": {
                         "id": "3",
                         "type": "EMAIL",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "4",
                       "item": "UNIQUE",
                       "value": {
                         "id": "4",
                         "type": "UNIQUE",
                         "events": [
                           "onBlur"
                         ]
                       }
                     },
                     {
                       "id": "5",
                       "item": "NOSPACE",
                       "value": {
                         "id": "5",
                         "type": "NOSPACE",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "6",
                       "item": "NOSPECIALCHAR",
                       "value": {
                         "id": "6",
                         "type": "NOSPECIALCHAR",
                         "events": [
                           "onkeyPress"
                         ]
                       }
                     },
                     {
                       "id": "7",
                       "item": "PATTERN",
                       "value": {
                         "id": "7",
                         "type": "PATTERN",
                         "events": [
                           "onBlur"
                         ]
                       }
                     }
                   ]
                 },
                 "operators": {
                   "value": "",
                   "control": "ListBoxCheckBox",
                   "selectedValues": [],
                   "values": [
                     {
                       "id": "1",
                       "item": "equal",
                       "value": {
                         "id": "1",
                         "type": "equal"
                       }
                     },
                     {
                       "id": "2",
                       "item": "not equal",
                       "value": {
                         "id": "2",
                         "type": "not equal"
                       }
                     },
                     {
                       "id": "3",
                       "item": "greater",
                       "value": {
                         "id": "3",
                         "type": "greater"
                       }
                     },
                     {
                       "id": "4",
                       "item": "greater & equal",
                       "value": {
                         "id": "4",
                         "type": "greater & equal"
                       }
                     },
                     {
                       "id": "5",
                       "item": "lower",
                       "value": {
                         "id": "5",
                         "type": "lower"
                       }
                     },
                     {
                       "id": "6",
                       "item": "lower & equal",
                       "value": {
                         "id": "6",
                         "type": "lower & equal"
                       }
                     },
                     {
                       "id": "7",
                       "item": "contains",
                       "value": {
                         "id": "7",
                         "type": "contains"
                       }
                     },
                     {
                       "id": "8",
                       "item": "starts with",
                       "value": {
                         "id": "8",
                         "type": "starts with"
                       }
                     },
                     {
                       "id": "9",
                       "item": "ends with",
                       "value": {
                         "id": "9",
                         "type": "ends with"
                       }
                     }
                   ]
                 },
                 "prefix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "suffix": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "wholeNumberLength": {
                   "value": 10,
                   "control": "TextBox"
                 },
                 "decimalSize": {
                   "value": 2,
                   "control": "TextBox"
                 },
                 "decimalSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "groupSize": {
                   "value": 3,
                   "control": "TextBox"
                 },
                 "groupSeparator": {
                   "value": "",
                   "control": "TextBox"
                 },
                 "index": {
                   "value": false,
                   "control": "CheckBox"
                 }
               },
               "policy": {
                 "read": true,
                 "edit": true,
                 "delete": true
               },
               "styles": {
                 "fontSize": {
                   "value": "14px"
                 },
                 "fontFamily": {
                   "value": "Arial"
                 },
                 "color": {
                   "value": "#212121"
                 },
                 "left": {
                   "value": 10,
                   "hide": true
                 },
                 "top": {
                   "value": 50,
                   "hide": true
                 },
                 "width": {
                   "value": "181px",
                   "hide": true
                 },
                 "display": {
                   "value": "flex",
                   "hide": true
                 },
                 "height": {
                   "value": "25px",
                   "hide": true
                 },
                 "visibility": {
                   "value": "visible"
                 },
                 "borderLeft": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTop": {
                   "value": "1px solid #cccccc"
                 },
                 "borderTopLeftRadius": {
                   "value": "2px"
                 },
                 "borderTopRightRadius": {
                   "value": "2px"
                 },
                 "borderRight": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottom": {
                   "value": "1px solid #cccccc"
                 },
                 "borderBottomLeftRadius": {
                   "value": "2px"
                 },
                 "borderBottomRightRadius": {
                   "value": "2px"
                 },
                 "background": {
                   "value": "white"
                 },
                 "boxSizing": {
                   "value": "border-box",
                   "hide": true
                 },
                 "textAlign": {
                   "value": "left"
                 },
                 "resize": {
                   "value": "both",
                   "hide": true
                 },
                 "overflow": {
                   "value": "auto",
                   "hide": true
                 }
               },
               "globalId": "d3840fad-3677-49c8-ab5b-a955b8b748ec",
               "parentId": [
                 21,
                 17,
                 1
               ],
               "parentGlobalId": [
                 "10b84a8f-adf0-40f1-9d59-9bd05510158b",
                 "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
                 "a4a285f5-8651-4a5a-8243-4428ff27cd27"
               ],
               "headerId": 47
             }
           ],
           "policy": {
             "read": true,
             "edit": true,
             "delete": true
           },
           "styles": {
             "fontSize": {
               "value": "14px"
             },
             "fontFamily": {
               "value": "Arial"
             },
             "color": {
               "value": "#cccccc"
             },
             "backgroundColor": {
               "value": "white"
             },
             "height": {
               "value": "30px",
               "hide": true
             },
             "width": {
               "value": "100%",
               "hide": true
             },
             "display": {
               "value": "flex",
               "hide": true
             },
             "position": {
               "value": "relative",
               "hide": true
             },
             "boxSizing": {
               "value": "border-box",
               "hide": true
             },
             "overflow": {
               "value": "hidden",
               "hide": true
             },
             "border": {
               "value": "1px solid #cccccc"
             }
           },
           "left": {
             "value": 19
           },
           "top": {
             "value": 136
           },
           "globalId": "10b84a8f-adf0-40f1-9d59-9bd05510158b",
           "parentId": [
             17,
             1
           ],
           "parentGlobalId": [
             "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
             "a4a285f5-8651-4a5a-8243-4428ff27cd27"
           ]
         }
       ],
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#cccccc"
         },
         "width": {
           "value": "1047px",
           "hide": true
         },
         "height": {
           "value": "529px",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "position": {
           "value": "absolute",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "zIndex": {
           "value": 1,
           "hide": true
         },
         "backgroundColor": {
           "value": "white"
         },
         "border": {
           "value": "1px solid #cccccc"
         },
         "overflow": {
           "value": "auto",
           "hide": true
         },
         "left": {
           "value": 19,
           "hide": true
         },
         "top": {
           "value": 133,
           "hide": true
         }
       },
       "excludesDropTypes": [
         "Label",
         "DataGrid",
         "Line",
         "Radio",
         "GroupBox",
         "Button",
         "RichTextBox",
         "TreeBox",
         "TextEditor"
       ],
       "parentId": [
         1
       ],
       "left": {
         "value": 19
       },
       "top": {
         "value": 136
       },
       "globalId": "1d05f75b-d3d2-4663-bd3e-260dbb9c32e1",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ],
       "clickRelativePosition": {
         "left": 980,
         "top": 48
       }
     },
     {
       "id": 11,
       "order": 2,
       "type": "AutoComplete",
       "properties": {
         "name": {
           "value": "AutoComplete11",
           "control": "TextBox"
         },
         "field": {
           "value": "AutoComplete",
           "control": "TextBox"
         },
         "type": {
           "value": "String",
           "control": "ListBox"
         },
         "actions": {
           "value": "",
           "control": "TextBox"
         },
         "toolTip": {
           "value": true,
           "control": "CheckBox"
         },
         "toolTipText": {
           "value": "",
           "control": "TextBox"
         },
         "actualize": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "size": {
           "value": 0,
           "control": "TextBox",
           "hide": true
         },
         "nullable": {
           "value": true,
           "control": "CheckBox"
         },
         "text": {
           "value": {
             "id": null,
             "item": ""
           },
           "control": "TextBox"
         },
         "index": {
           "value": false,
           "control": "CheckBox"
         },
         "placeholder": {
           "value": "AutoComplete",
           "control": "TextBox"
         },
         "data": {
           "value": {
             "list": {},
             "mapping": {}
           },
           "options": [
             "List",
             "Mapping"
           ],
           "control": "TextBox"
         },
         "validations": {
           "value": "",
           "control": "ListBoxCheckBox",
           "selectedValues": [],
           "values": [
             {
               "id": "1",
               "item": "REQUIRE",
               "value": {
                 "id": "1",
                 "type": "REQUIRE",
                 "events": [
                   "onBlur",
                   "onSubmit"
                 ]
               }
             },
             {
               "id": "4",
               "item": "UNIQUE",
               "value": {
                 "id": "4",
                 "type": "UNIQUE",
                 "events": [
                   "onBlur"
                 ]
               }
             }
           ]
         }
       },
       "policy": {
         "read": true,
         "edit": true,
         "delete": true
       },
       "styles": {
         "fontSize": {
           "value": "14px"
         },
         "fontFamily": {
           "value": "Arial"
         },
         "color": {
           "value": "#212121"
         },
         "left": {
           "value": 821,
           "hide": true
         },
         "top": {
           "value": 21,
           "hide": true
         },
         "width": {
           "value": "242px",
           "hide": true
         },
         "height": {
           "value": "24px",
           "hide": true
         },
         "display": {
           "value": "flex",
           "hide": true
         },
         "boxSizing": {
           "value": "border-box",
           "hide": true
         },
         "resize": {
           "value": "both",
           "hide": true
         },
         "overflow": {
           "value": "auto",
           "hide": true
         },
         "border": {
           "value": "none"
         },
         "position": {
           "value": "absolute"
         }
       },
       "parentId": [
         1
       ],
       "left": {
         "value": 764
       },
       "top": {
         "value": 21
       },
       "globalId": "976e17ec-1ccc-471f-b399-5605ee822f87",
       "parentGlobalId": [
         "a4a285f5-8651-4a5a-8243-4428ff27cd27"
       ]
     }
   ],
   "globalId": "a4a285f5-8651-4a5a-8243-4428ff27cd27",
   "styles": {
     "border": {
       "value": "1px solid #cccccc"
     },
     "backgroundColor": {
       "value": "white"
     },
     "margin": {
       "value": "0 auto",
       "hide": true
     },
     "color": {
       "value": "#212121"
     },
     "width": {
       "value": "1086px",
       "hide": true
     },
     "resize": {
       "value": "auto",
       "hide": true
     },
     "position": {
       "value": "relative",
       "hide": true
     },
     "height": {
       "value": "692px",
       "hide": true
     }
   },
   "id": 1,
   "type": "Form",
   "parentGlobalId": [],
   "parentId": [],
   "properties": {
     "name": {
       "value": "Form",
       "control": "TextBox"
     },
     "text": {
       "value": "Form",
       "control": "TextBox"
     },
     "actualize": {
       "control": "TextBox",
       "hide": true,
       "value": 0
     },
     "actions": {
       "value": "",
       "control": "TextBox"
     }
   },
   "order": 1,
   "policy": {
     "read": true,
     "edit": true,
     "delete": true
   }
 }],

  apiSchemas:[],
 currentMetaData:{id:0, maxId:0,  isSealed:false}


}
  const  [user, setUser] = useState({ 
    id: uuid.v4(),
    firstName : "",
    lastName : "",
    email : "",
    password : Math.floor(1000 + Math.random() * 9000),
    resetPassword : true,
    errors:[],
    loading:false,
    canEdit:false,
    organigramId : new URLSearchParams(useLocation().search).get("organigramId"),
    profilGlobalId : new URLSearchParams(useLocation().search).get("profilGlobalId"),
    isEqual:false,
    isUpdate:false,
 })

  const refreshData =(result, currentFormData = undefined) => {
   var updatedFormData = currentFormData ? currentFormData : JSON.parse(JSON.stringify(globalState.state.formData));
   if (!updatedFormData.apiData) 
      updatedFormData.apiData = []
   else
      updatedFormData.apiData = updatedFormData.apiData.filter(item => item.globalId != formData.apiSchemas[0].globalId)
   updatedFormData.apiData.push({globalId:formData.apiSchemas[0].globalId, id:formData.apiSchemas[0].id,  data:result})
   dispatch({
     type: "UPDATE_FORM_WITOUT_HISTORIQUE",
     payload: updatedFormData
   });  };
  
  const onSelectProfil = (itemSelected) => {
   
    var userData = JSON.parse(JSON.stringify(user));
    setUser({...userData, loading:true })
    axiosOperation({method:"GET"
      , url: "https://flex-services.onrender.com/profilUser/?id="+ itemSelected.id
      , body: {confirmed:true, nTry:0}
      }).then(response => 
        { 
          
         if(response.managedError) {
            
            const result = response.result.data
            if (result[0]) {
              
               //refreshData(result)
               var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
               const emptyValue = ""
               setCurrentRowData(updatedFormData, emptyValue)
         
               setUser({...user, profilGlobalId:itemSelected.id, showDelete:false, loading:false, canEdit:false
                  ,firstName:emptyValue,lastName:emptyValue, email:emptyValue, isUpdate:false,isEqual:true})
         
               refreshData(result, updatedFormData)
              
            } else setUser({...user, loading:false, profilGlobalId:itemSelected.id})
         } else setUser({...user, loading:false, profilGlobalId:itemSelected.id})
       
          
        })
    
  }

  const setCurrentRowData = (updatedFormData, value=undefined) => {
  
   var newValue = {}
  
   var currentsTools = [];
   getCurrentsTools(updatedFormData, currentsTools, [firstNameId, lastNameId, emailId]);
   currentsTools.filter(item => {
      switch (item.id) {
         case firstNameId:
            item.properties.text.value = value != undefined ? value : getCurrentRowComponentValue(headerFirstNameId)
            newValue["firstName"] = item.properties.text.value
            break;
         case lastNameId:
            item.properties.text.value = value != undefined  ? value :getCurrentRowComponentValue(headerLastNameId)
            newValue["lastName"] = item.properties.text.value
            break;
         case emailId:
            
            item.properties.text.value = value != undefined  ? value :getCurrentRowComponentValue(headerEmailId)
            newValue["email"] = item.properties.text.value
            break;
      }   
      
   });
   
   updatedFormData.errors = []
   
   return newValue
  };

 const getCurrentRowComponentValue = (id) => {
  
   return globalState.state.formData.currentRow[0].metaData.filter(item => item.headerId == id)[0].properties.text.value
 }
  

  useEffect(() => {
   
    dispatch({
      type: "SET_META_DATA",
      payload: formData
    });
      
  }, []);
  
  
 return (

    <React.Fragment>

      {/*settings.showDiscard && <SimpleDialog changeModeRequired ={false} 
              onClickValid ={(e) => onDiscard(e)} onClose = {() => setSetting({...settings, showDiscard:false})}  
              value = "Are you sure ?"
              isLabel = {true}
        parentId = "InformationDiscardCommand" type = "field" operation = "DISCARD"/>*/}
      <FormSettings isExecutionMode = {true}/>
    
    {/*<div style = {{ marginLeft:"auto",  marginRight:"auto",width:"760px"  }}>
      
    </div>*/}
    </React.Fragment>
  );
};

/*

      <div style = {{ display:"flex" ,marginTop:"10px" ,marginBottom:"10px"  }}>
        
        {isNewRegister && <input id="FistName" type="textBox" placeholder="First Name" value={user.fistName}  
          onChange={(e)=> setUser({...user, fistName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"FistName", name:"First Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"FistName" })}
          style = {{ marginRight:"10px", fontSize:"14px"   }}
          className="input connexionInput" />}
        {isNewRegister && getError("FistName")}
        
        
        {isNewRegister && <input id="LastName" type="textBox" placeholder="Last Name" value={user.lastName} 
          onChange={(e)=> setUser({...user, lastName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"LastName", name:"Last Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"LastName" }, [{type :"REQUIRE"}])}
          style = {{ marginRight:"10px" , fontSize:"14px"  }}
          className="input connexionInput" />}
        { isNewRegister && getError("LastName")}
        
        
        {<input id="Email" type="textBox" placeholder="Email" value={user.email} 
          readOnly={user.log && user.log.activeResendEmail} 
          onChange={(e)=> setUser({...user, email:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"Email", name:"Email" }, [{type :"REQUIRE"}, {type :"EMAIL"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"Email" })}
          style = {{ fontSize:"14px"   }}
          className="input connexionInput" />}
        {isNewRegister && getError("Email")}      
        
      </div>
      
<div style = {{ textAlign:"center", display:"flex" }}>
        <Link  style = {{ fontFamily:"Verdana", marginRight:"auto", textDecoration: "none"  }}to="/register">
          <span style = {{ fontSize:"12px", color:"#008dff"}} >Forget password?</span>
        </Link>
        <Link style = {{ fontFamily:"Verdana", marginLeft:"auto", textDecoration: "none"  }} to="/register">
          <span style = {{ fontSize:"12px", color:"yellowGreen" }} >Sign In</span>
        </Link>
      </div>
  */


